import { ApolloProvider as BaseApolloProvider } from "@apollo/client";
import React, { ReactElement } from "react";

import { useTenantApolloClient } from "../client";
import { useOnBeforeNavigate } from "./OnBeforeNavigateProvider";

export default function CacheClearingApolloProvider({
  children,
}: {
  children: React.ReactNode;
}): ReactElement {
  const tenantClient = useTenantApolloClient();

  useOnBeforeNavigate(async () => {
    await tenantClient.cache.reset();
  });

  return (
    <BaseApolloProvider client={tenantClient}>{children}</BaseApolloProvider>
  );
}
